module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-rnd-salesforce.018fb48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-rnd-salesforce.png
// module id = nOhN
// module chunks = 0